import React, { useState, useEffect } from 'react';
import { TabBar } from 'antd-mobile';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';
import {
    AppOutline,
    MessageOutline,
    BillOutline,
    UserOutline
} from 'antd-mobile-icons';
import { useTenant } from '@/features/tenant/context/TenantContext';

export const MobileLayout: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { tenantCode } = useTenant();
    const [activeKey, setActiveKey] = useState(location.pathname);

    // Sync active tab with URL
    useEffect(() => {
        // Simple logic to match route to tab key
        // Assuming routes are /:tenant/dashboard, /:tenant/mail, etc.
        const path = location.pathname;
        if (path.includes('/dashboard')) setActiveKey('dashboard');
        else if (path.includes('/mail')) setActiveKey('mail');
        else if (path.includes('/bills')) setActiveKey('bills');
        else if (path.includes('/me')) setActiveKey('me');
    }, [location.pathname]);

    const tabs = [
        {
            key: 'dashboard',
            title: '首页',
            icon: <AppOutline />,
        },
        {
            key: 'mail',
            title: '信件',
            icon: <MessageOutline />,
        },
        {
            key: 'bills',
            title: '账单',
            icon: <BillOutline />,
        },
        {
            key: 'me',
            title: '我的',
            icon: <UserOutline />,
        }
    ];

    const handleChange = (key: string) => {
        setActiveKey(key);
        // Assuming standardized routes
        navigate(`/${tenantCode}/${key}`);
    };

    return (
        <div className="flex flex-col h-[100dvh] bg-black text-white">
            <div className="flex-1 overflow-auto">
                <Outlet />
            </div>
            <div className="border-t border-white/10 bg-black/80 backdrop-blur-md pb-safe">
                <TabBar activeKey={activeKey} onChange={handleChange} safeArea>
                    {tabs.map(item => (
                        <TabBar.Item key={item.key} icon={item.icon} title={item.title} />
                    ))}
                </TabBar>
            </div>
        </div>
    );
};
